module.exports = __webpack_public_path__ + "img/pinterest-fill.ffdb2162.svg";